/**
 * Search Action Logging Utility
 *
 * Sends a GA4 "search" event (if available) and optionally logs in dev mode.
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events#search
 */

import appSettings from '../config/settings';
import { trackRedditSearch } from './redditPixelEvents';

export const SEARCH_SOURCES = {
  TOPBAR: 'topbar',
};

export const SEARCH_TYPES = {
  KEYWORDS: 'keywords',
  LOCATION: 'location',
};

export const logSearch = ({ term, type, source } = {}) => {
  const cleanedTerm = typeof term === 'string' ? term.trim() : '';
  if (!cleanedTerm) return null;

  const payload = {
    event: 'search',
    term: cleanedTerm,
    type,
    source,
    timestamp: new Date().toISOString(),
    url: typeof window !== 'undefined' ? window.location.href : 'server',
    environment: appSettings.env,
  };

  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', 'search', {
        search_term: cleanedTerm,
        search_type: type,
        search_source: source,
      });
    } catch (_) {
      // Silently fail analytics
    }
  }

  trackRedditSearch(cleanedTerm);

  if (appSettings.dev) {
    // eslint-disable-next-line no-console
    console.log('Analytics event:', payload);
  }

  return payload;
};
